/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CheckListItemViewModel } from "../types/CheckListItemViewModel.ts";

export const checkListItemViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  checkListId: z.optional(z.number().int()),
  description: z.string().nullish(),
  active: z.optional(z.boolean()),
}) as unknown as ToZod<CheckListItemViewModel>;
